import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from "prop-types";
import React from "react";

var GlobalFooterLogoContainer = function GlobalFooterLogoContainer(_ref) {
  var href = _ref.href,
      ariaLabel = _ref.ariaLabel,
      props = _objectWithoutProperties(_ref, ["href", "ariaLabel"]);

  if (href) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: href,
      "aria-label": ariaLabel
    }, props), props.children);
  }

  return /*#__PURE__*/React.createElement("div", props);
};

GlobalFooterLogoContainer.propTypes = {
  /**
   * URL.
   */
  href: PropTypes.string,

  /**
   * link target for the logo link
   */
  target: PropTypes.string,

  /**
   * aria label for the logo link
   */
  ariaLabel: PropTypes.string,

  /**
   * Children
   */
  children: PropTypes.node.isRequired
};
GlobalFooterLogoContainer.defaultProps = {
  href: null
};
export default GlobalFooterLogoContainer;